import React, { useEffect } from "react";
import { IProps } from "./types";
import { FormElement, Label } from "../../../../../components/Form";
import { Address, MapContainer } from "./styles";
import { useTheme } from "styled-components";
import messages from "./messages";
import { FormattedMessage } from "react-intl";

const Venue = ({ location }: IProps) => {
    const theme = useTheme();
    if (!location?.address) return null;
    const [lng, lat] = location.geometry.coordinates;
    const zoom = 15;
    useEffect(() => {
        const initMap = async () => {
            const position = { lat, lng };
            const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
            const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

            const map = new Map(
                document.getElementById('choir-map') as HTMLElement,
                {
                    zoom,
                    center: position,
                    mapId: 'choir-map',
                    disableDefaultUI: true,
                    gestureHandling: 'none',
                    clickableIcons: false,
                }
            );
            const pinBackground = new PinElement({
                background: theme.c.active,
                borderColor: theme.c.dark,
                glyphColor: theme.c.dark
            });

            new AdvancedMarkerElement({
                map: map,
                position: position,
                title: location.address,
                content: pinBackground.element
            });
        }
        initMap();
    }, []);

    const { data: { postal_code }, address, name } = location;

    const isNameInAddress = address.includes(name);
    return (
        <FormElement>
            <Label><FormattedMessage {...messages.rehearsalVenue} /></Label>
            <a style={{ cursor: 'pointer'}} href={`https://www.google.com/maps?q=${location.address.replace(/ /g, "+")}&ll=${lat},${lng}&z=${zoom}`} target="_blank">
                <MapContainer id="choir-map" />
            </a>
            <Address>
                {name && !isNameInAddress && (
                    <>
                        {name}
                        <br/>
                    </>
                )}
                {postal_code} {address.slice(0, address.indexOf(postal_code) - 2)}
            </Address>
        </FormElement>
    );
};

export default Venue;
